export const addTimeToDate = (date: Date, days: number, hours: number, minutes: number) => {
    const newDate = new Date(date);

    newDate.setDate(newDate.getDate() + days);
    newDate.setHours(newDate.getHours() + hours);
    newDate.setMinutes(newDate.getMinutes() + minutes);

    return newDate;
};

export const getMeridiem = (date: Date) => {
    const currentHour = date.getHours();

    return currentHour >= 12 ? 'PM' : 'AM';
};

export const get12HourFromDate = (date: Date) => {
    const currentHour = date.getHours();

    return currentHour % 12 || 12;
};

const MILLISECONDS_PER_MINUTE = 60000;

const toDate = (value: Date | string): Date =>
    typeof value === 'string' ? new Date(value) : value;

export const calcDurationMinutes = (startTime: Date | string, endTime: Date | string): number =>
    Math.round((toDate(endTime).getTime() - toDate(startTime).getTime()) / MILLISECONDS_PER_MINUTE);
